import React, { Component } from "react";
import { Map, List } from "immutable";

import OfferResponseFilters from "./OfferResponseFilters";
import OfferGroupsFilterPanels from "./OfferGroupsFilterPanels";
import FlightOfferGroup from "./FlightOfferGroup";
import FlightCombinedOfferGroup from "./FlightCombinedOfferGroup";

class FlightOffersResponse extends Component {
  constructor() {
    super();
    this.state = {
      // Per-response filters. Externalised, so that we can
      // display them in a separate, docked filter panel
      filterByOfferGroup: Map(),
      listView: true
    };
  }

  componentDidMount() {
    if (this.props.showCompact) {
      this.setState({ listView: false });
    }
  }

  updateFilter = (index, filterFn) => {
    this.setState({
      filterByOfferGroup: this.state.filterByOfferGroup.set(index, filterFn)
    });
  };

  toggleFlightView(e) {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    this.setState({ listView: !this.state.listView });
  }

  render() {
    const {
      flightGetOffersResponse = Map(),
      combinedOffersIndex = List(),
      flightCombinedOffersResponse = Map(),
      selectOffer,
      unselectOffer,
      selectionByOfferGroup,
      referenceData,
      startBooking,
      toggleFilterPanel,
      filterPanelOpen
    } = this.props;
    const { filterByOfferGroup, listView } = this.state;

    const offerGroups = this.state.listView
      ? flightGetOffersResponse.get("offerGroup", List())
      : flightCombinedOffersResponse.get("combinedOfferGroup", List());
    return (
      <div className="container offer-response">
        <OfferResponseFilters
          onFilterToggle={toggleFilterPanel}
          onViewToggle={this.toggleFlightView.bind(this)}
          listView={this.state.listView}
          view="book-a-flight"
        />
        <div className="result-list flights-result-list">
          <OfferGroupsFilterPanels
            offerGroups={flightGetOffersResponse.get("offerGroup", List())}
            visible={filterPanelOpen}
            updateFilter={this.updateFilter.bind(this)}
            view="book-a-flight"
          />
          <div className="view offer-groups">
            {listView &&
              offerGroups.map((og = Map(), i) => (
                <FlightOfferGroup
                  offerGroup={og}
                  filterFn={filterByOfferGroup.get(i)}
                  groupNo={i}
                  showHeading={offerGroups.size > 1}
                  passengerCount={flightGetOffersResponse.getIn(["participants", "participant"], List()).size}
                  airportByIata={referenceData.airportByIata}
                  selectOffer={u => selectOffer(i, u)}
                  unselectOffer={u => unselectOffer(i, u)}
                  selectedOffers={selectionByOfferGroup.get(i)}
                  key={i}
                />
              ))}
            {!listView &&
              offerGroups.map((og = Map(), i) => (
                <FlightCombinedOfferGroup
                  showMoreOptions={this.props.showCompact}
                  offerGroup={og}
                  combinedOffersIndex={combinedOffersIndex}
                  filterFn={filterByOfferGroup.get(i)}
                  groupNo={i}
                  showHeading={offerGroups.size > 1}
                  passengerCount={flightCombinedOffersResponse.getIn(["participants", "participant"], List()).size}
                  airportByIata={referenceData.airportByIata}
                  selectOffer={u => selectOffer(i, u)}
                  unselectOffer={u => unselectOffer(i, u)}
                  selectedOffers={selectionByOfferGroup.get(i)}
                  key={i}
                />
              ))}
            {/* Ready to book? (a selection for each offergroup) */}
            {selectionByOfferGroup.size === offerGroups.size && selectionByOfferGroup.every(sel => sel.size > 0) && (
              <footer>
                <button className="btn btn-primary min-width-140" onClick={startBooking}>
                  Book
                </button>
              </footer>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default FlightOffersResponse;



// WEBPACK FOOTER //
// ./src/ndc/offer/FlightOffersResponse.js